export function recordAccessClick(key: React.Key) {
  const accessLog = localStorage.getItem('accessLogs');

  const logs: React.Key[] = accessLog ? JSON.parse(accessLog) : [];

  const index = logs.indexOf(key);

  if (index === -1) {
    if (logs.length < 4) {
      logs.unshift(key);
    } else {
      logs.unshift(key);
      logs.pop();
    }
  } else {
    logs.splice(index, 1);
    logs.unshift(key);
  }

  localStorage.setItem('accessLogs', JSON.stringify(logs));
}
